/* istanbul ignore file */
export { default } from './ValuesDisplay';
